import {
  Box,
  Button,
  Card,
  CardContent,
  Container,
  FormControl,
  Grid,
  InputLabel,
  Select,
  Typography,
} from "@mui/material";
import React, { useState, useEffect } from "react";
import { DataGrid, type GridColDef } from "@mui/x-data-grid";
import axiosInstance from "../../api/base/axios";
import { DatePicker } from "@mui/x-date-pickers";
import dayjs, { Dayjs } from "dayjs";

interface IRecruitments {
  msisdn: string;
  message: string;
  response: string;
  date: string;
}

const SmsLogsPerDate = () => {
  const [loading, setLoading] = useState<boolean>(false);
  const [open, setOpen] = useState<boolean>(false);
  const [date, setDate] = useState<Dayjs | null>(dayjs());
  const [recruitments, setRecruitments] = useState<IRecruitments[]>([]);

  const handleModal = () => {
    setOpen(!open);
  };

  const fetchRecruitments = async (): Promise<any> => {
    try {
      setLoading(true);
      await axiosInstance
        .get(`/skiza/report/sms_logs/${dayjs(date).format("YYYY-MM-DD")}`)
        .then((res) => {
          setRecruitments(res.data.sms_logs);
          setLoading(false);
        });
    } catch (error) {
      setLoading(false);
      console.log("err", error);
    }
  };

  useEffect(() => {
    fetchRecruitments();
  }, [date]);

  const columns: Array<GridColDef<IRecruitments>> = [
    {
      field: "msisdn",
      headerName: "Phone number",
      flex: 1,
    },
    {
      field: "message",
      headerName: "message",
      flex: 1,
    },
    {
      field: "response",
      headerName: "Response",
      flex: 1,
    },
    {
      field: "date",
      headerName: "Date",
      flex: 1,
    },
  ];

  function generateRandom() {
    var length = 8,
      charset =
        "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789",
      retVal = "";
    for (var i = 0, n = charset.length; i < length; ++i) {
      retVal += charset.charAt(Math.floor(Math.random() * n));
    }
    return retVal;
  }

  return (
    <Container maxWidth={false}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Card elevation={4}>
            <CardContent>
              <Grid container spacing={2}>
                <Grid item flex={1}>
                  <Typography variant="h4">Sms logs per date</Typography>
                </Grid>

                <Grid item>
                  <DatePicker
                    label="Date picker"
                    value={date}
                    onChange={(newValue) =>
                      setDate(dayjs(newValue, "YYYY-MM-DD"))
                    }
                    open={open}
                    onClose={() => setOpen(false)}
                    slotProps={{
                      textField: {
                        onClick: () => setOpen(true),
                      },
                    }}
                  />
                </Grid>

                <Grid item xs={12} sx={{ height: "calc(100vh - 180px)" }}>
                  <DataGrid
                    getRowId={(row) => generateRandom()}
                    initialState={{
                      sorting: { sortModel: [{ field: "date", sort: "desc" }] },
                    }}
                    loading={loading}
                    columns={columns}
                    rows={recruitments}
                  />
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Container>
  );
};

export default SmsLogsPerDate;
